// extracted by mini-css-extract-plugin
export default {"modal_box":"modal_modal_box__kvlZ1","modal_close":"modal_modal_close__o0KW+","view":"modal_view__9nf6r"};